import React, { useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';

export type ImageOption = {
  src: string;
  filename: string;
  key: string;
};

export const ImagePickerDialog: React.FC<{
  images: ImageOption[];
  selectedImage: ImageOption | null;
  onSelect: (image: ImageOption | null) => void;
  onClose: () => void;
}> = ({ images, selectedImage, onSelect, onClose }) => {
  const dialogRef = useRef<HTMLDialogElement>(null);

  useEffect(() => {
    dialogRef.current.showModal();
  }, []);

  return (
    ReactDOM.createPortal(
      <dialog ref={dialogRef} className="modal image-picker" aria-labelledby="dialogTitle" onClose={onClose}>
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title">Select an Image</h1>
              <button type="button" className="btn-close" aria-label="Close" onClick={onClose}></button>
            </div>
            <div className="modal-body">
              <div className="row g-2">
                {images.map((img) => (
                  <div key={img.key} className="col-4">
                    <img
                      src={img.src}
                      alt={img.filename}
                      className="w-100"
                      tabIndex={0}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          onSelect(img);
                          onClose();
                        }
                      }}
                      onClick={() => {
                        onSelect(img);
                        onClose();
                      }}
                    />
                    <small className="d-block text-center text-muted mt-1 text-truncate">
                      {img.filename}
                    </small>
                  </div>
                ))}
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-outline-primary"
                onClick={() => {
                  onSelect(null);
                  onClose();
                }}
              >
                Clear Selection
              </button>
              <button type="button" className="btn btn-outline-primary" onClick={onClose}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      </dialog>,
      document.body
    )
  );
};
